import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $AccountFormsModuleName } from "./accountForms.types";

const getAccountForms = () => (state: IState) =>
    getValueState(state, $AccountFormsModuleName);

export { getAccountForms };
